/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduleFilterItemsDto } from '../../models/schedule-filter-items-dto';

export interface AllScheduleControllerGetParentFilterItems$Params {
}

export function allScheduleControllerGetParentFilterItems(http: HttpClient, rootUrl: string, params?: AllScheduleControllerGetParentFilterItems$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleFilterItemsDto>> {
  const rb = new RequestBuilder(rootUrl, allScheduleControllerGetParentFilterItems.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduleFilterItemsDto>;
    })
  );
}

allScheduleControllerGetParentFilterItems.PATH = '/api/all-schedule/parent/filter';
